import * as z from 'zod'

export const datepickerAvailabilityResultsSchema = z
  .object({
    date: z.string(),
    bookable_dates: z.string().array(),
  })
  .array()
